/**
 * Product page accordions (Descrição, Envio e devoluções, Compra segura),
 * Scuffers style: the panel slides open/closed instead of jumping, and after
 * opening the view scrolls down smoothly so the opened content is visible.
 *
 * Works on the native <details> element, so without JS (or with reduced
 * motion) it still opens and closes normally.
 */
(function () {
  var DURATION = 300;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function scrollParent(el) {
    for (var node = el.parentElement; node; node = node.parentElement) {
      var overflowY = getComputedStyle(node).overflowY;
      // No scrollHeight check: while the panel is mid-animation the column
      // is momentarily not taller than its box, but it is still the scroller.
      if (node !== document.body && node !== document.documentElement && (overflowY === 'auto' || overflowY === 'scroll')) {
        return node;
      }
    }
    return null;
  }

  // Ease-in-out, matching the height animation's curve closely enough that
  // the panel growing and the view scrolling read as one movement.
  function ease(t) {
    return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
  }

  function tweenScroll(getY, setY, to) {
    var from = getY();
    if (Math.abs(to - from) < 1) return;
    if (reduceMotion.matches) return setY(to);
    var startTime = null;
    function frame(now) {
      if (startTime === null) startTime = now;
      var t = Math.min((now - startTime) / DURATION, 1);
      setY(from + (to - from) * ease(t));
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // Scroll so the opened panel is visible. A panel taller than the visible
  // area is aligned to its top (so the reader starts at the beginning of the
  // text); a shorter one only scrolls as far as needed to fit its bottom.
  // 'panelHeight' is the FINAL height, since the panel is still growing when
  // this runs. On desktop only the pinned side column scrolls (not the page);
  // on mobile the page itself scrolls.
  function revealPanel(details, panelHeight) {
    var parent = scrollParent(details);
    var margin = 8;
    var rect = details.getBoundingClientRect();
    if (parent) {
      var parentRect = parent.getBoundingClientRect();
      var top = rect.top - parentRect.top;
      var current = parent.scrollTop;
      var target = current;
      if (panelHeight > parent.clientHeight * 0.85 || top < 0) {
        target = current + top - margin;
      } else if (top + panelHeight > parent.clientHeight) {
        target = current + top + panelHeight - parent.clientHeight + margin;
      }
      tweenScroll(function () { return parent.scrollTop; }, function (y) { parent.scrollTop = y; }, Math.max(0, target));
    } else {
      var headerOffset = 80;
      var pageTarget = window.scrollY;
      if (panelHeight > window.innerHeight * 0.85 || rect.top < headerOffset) {
        pageTarget = window.scrollY + rect.top - headerOffset;
      } else if (rect.top + panelHeight > window.innerHeight) {
        pageTarget = window.scrollY + rect.top + panelHeight - window.innerHeight + margin;
      }
      tweenScroll(function () { return window.scrollY; }, function (y) { window.scrollTo(0, y); }, Math.max(0, pageTarget));
    }
  }

  function animate(details, from, to, onFinish) {
    if (details._accordionAnimation) {
      // Detach first: a cancelled close must not run its "finish" step
      // (which sets open = false) after the panel has been re-opened.
      details._accordionAnimation.onfinish = details._accordionAnimation.oncancel = null;
      details._accordionAnimation.cancel();
    }
    details.style.overflow = 'hidden';
    var animation = details.animate({ height: [from + 'px', to + 'px'] }, { duration: DURATION, easing: EASING });
    details._accordionAnimation = animation;
    animation.onfinish = animation.oncancel = function () {
      details._accordionAnimation = null;
      details.style.overflow = '';
      if (onFinish) onFinish();
    };
  }

  function open(details) {
    details.dataset.closing = 'false';
    var startHeight = details.offsetHeight;
    details.open = true;
    var endHeight = details.offsetHeight;
    if (reduceMotion.matches) return revealPanel(details, endHeight);
    // Scroll while it expands (not after), so it feels like one movement.
    revealPanel(details, endHeight);
    animate(details, startHeight, endHeight);
  }

  function close(details) {
    if (reduceMotion.matches) {
      details.open = false;
      return;
    }
    details.dataset.closing = 'true';
    var startHeight = details.offsetHeight;
    var summary = details.querySelector('summary');
    var endHeight = summary ? summary.offsetHeight : 0;
    animate(details, startHeight, endHeight, function () {
      details.open = false;
      details.dataset.closing = 'false';
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('.product__accordion summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || details.tagName !== 'DETAILS') return;

    event.preventDefault();
    var isOpening = !details.open || details.dataset.closing === 'true';
    if (isOpening) open(details);
    else close(details);
  });
})();
